import * as React from "react";
import { ButtonProps, Button } from "semantic-ui-react";
import { LoadingState, areRequestsActive } from "redux-request-loading";
import { useSelector } from "react-redux";

interface Props extends ButtonProps {
    requestNames: string | string[];
    disabled?: boolean;
    loading?: boolean;
}

export const IsLoadingButton: React.FunctionComponent<Props> = (props) => {
    const { loading: loadingFromProps, requestNames, type, disabled, ...buttonProps } = props;
    const loading =
        useSelector((state: LoadingState) => areRequestsActive(state, Array.isArray(requestNames) ? requestNames : [requestNames])) || loadingFromProps;
    return <Button type={type || "button"} {...buttonProps} loading={loading} disabled={loading || disabled} />;
};

